import { getClosestConfigurationFromRoundTable } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';

function mergeLabel(table, compiledLabel) {
    table.label = {
        ...table.label,
        compiled: {
            ...compiledLabel,
        },
        transformation: {
            rotation: -table.transformation.rotation,
        },
    };

    return table;
}

function compileRoundTableLabel(table) {
    const configuration = getClosestConfigurationFromRoundTable(table, 'fontConfig');
    const { spacing } = getClosestConfigurationFromRoundTable(table, 'spacing');

    const {
        label: { text, manual },
        compiled: { polygon: { dimensions: { height } } },
        transformation: { rotation },
    } = table;

    if (text === null) {
        return table;
    }

    const compiledLabel = {
        ...table.label.compiled,
        size: configuration.fontConfig.size.roundTable,
        family: configuration.fontConfig.family,
        color: configuration.fontConfig.color,
    };

    if (manual) {
        return mergeLabel(table, compiledLabel);
    }

    let spacingMultiplier = 0.5;
    if (table.seats.count() > 0) {
        spacingMultiplier = 1.5;
    }

    compiledLabel.x = 0;
    compiledLabel.y = -(height / 2 + spacing.h * spacingMultiplier);
    compiledLabel.text = { ...compiledLabel.text, x: compiledLabel.x, y: compiledLabel.y };

    return mergeLabel(table, compiledLabel);
}

export default compileRoundTableLabel;
